export default __webpack_public_path__ + "static/Internet-Things-f4d3119e555075d960ebd7fde2bc655b.webp";